export default __webpack_public_path__ + "static/media/marauders-map-v4-gallery-13.1eb24736.jpg";